import React from "react"
import { Cell } from "fixed-data-table-2"

// helper functions
import { cleanUpHtml } from "shared/imports/sharedHelperFunctions"

export const GrassrootsActionDatumCell = ({ datum, ...props }) => (
    <Cell {...props}>
        {props.isResourceTable ? (
            <React.Fragment>
                <span>{cleanUpHtml(datum.get("humanized_text"))}</span>
            </React.Fragment>
        ) : (
            <React.Fragment>
                <span>{datum.get("raw_content")}</span>
            </React.Fragment>
        )}
    </Cell>
)

export default GrassrootsActionDatumCell
